module.exports = __webpack_public_path__ + "static/assets/5c1bb7c7eb8d79a500f42d52621cdc64.gif";